<div class="content-header">
  <div class="header-title">
    <h1>Users Management</h1>
  </div>
  <div></div>
</div>

<div class="toolbar">
  <form class="user-search" (submit)="onSearchSubmit($event)">
    <span class="search-label">Search User:</span>
    <sdc-input
      name="user-search"
      placeholder="Search user using username"
      [control]="searchControl"
      [attr.data-cy]="'user-search-input'" />
    <div class="search-actions">
      <sdc-button
        variant="glass"
        size="sm"
        type="submit"
        [attr.data-cy]="'user-search-button'">
        <span>Search</span>
        <ng-icon name="lucideSearch" aria-hidden="true" />
      </sdc-button>
      @if (activeSearch) {
        <sdc-button variant="secondary" (onClick)="clearSearch()"
          >Clear</sdc-button
        >
      }
    </div>
  </form>
  <div class="toolbar-actions">
    <sdc-button
      variant="primary"
      (onClick)="openModalCreate()"
      [attr.data-cy]="'user-create-button'">
      Create New User
    </sdc-button>
    <sdc-button
      variant="primary"
      (onClick)="csvFile.click()"
      [attr.data-cy]="'user-upload-csv-button'">
      Upload CSV
    </sdc-button>
    <input
      type="file"
      class="file-input-hidden"
      #csvFile
      (change)="onFileChange($event)" />
  </div>
</div>

@if (data.length === 0) {
  <div class="not-found">
    <span>No user was found</span>
  </div>
} @else {
  <gs-table [data]="data" [columns]="columns" [loading]="loading()"></gs-table>
}
<p class="legend">
  Showing {{ data.length }} of {{ totalItemsInDb }} total Users
</p>

<app-pagination
  #pagination
  [totalItemsInDb]="totalItemsInDb"
  [itemsPerPage]="itemsPerPage"></app-pagination>
